import { IMedsusCard } from './cardMedsusItem';

export const mockData: IMedsusCard[] = [
  {
    id: '1',
    tipo: 'PCDT',
    titulo: 'PROTOCOLO CLÍNICO E DIRETRIZES TERAPÊUTICAS DA ARTRITE REUMATOIDE',
    abrangencia: 'Estadual - São Paulo',
    responsavelAquisicao: 'Secretaria de Saúde do Estado de São Paulo',
    componente: 'BÁSICO',
    status: 'ATIVO',
    resumo:
      'Estabelece critérios diagnósticos e terapêuticos para o manejo da artrite reumatoide no âmbito do SUS, incluindo medicamentos de primeira e segunda linha.',
    tags: ['Artrite Reumatoide', 'Reumatologia', 'PCDT'],
  },
  {
    id: '2',
    tipo: 'PCDT',
    titulo:
      'PROTOCOLO CLÍNICO E DIRETRIZES TERAPÊUTICAS DA DIABETES MELLITUS TIPO 2',
    abrangencia: 'Nacional',
    responsavelAquisicao: 'Ministério da Saúde',
    componente: 'ESPECIALIZADO',
    status: 'ATUALIZADO',
    resumo:
      'Define diretrizes para diagnóstico, tratamento farmacológico e monitoramento de pacientes com diabetes mellitus tipo 2.',
    tags: ['Diabetes', 'Endocrinologia'],
  },
  {
    id: '3',
    tipo: 'DDT',
    titulo: 'DIRETRIZ DIAGNÓSTICA E TERAPÊUTICA DA ESCLEROSE MÚLTIPLA',
    abrangencia: 'Nacional',
    responsavelAquisicao: 'Ministério da Saúde',
    componente: 'ESPECIALIZADO',
    status: 'EM CONSULTA PÚBLICA',
    resumo:
      'Orienta o diagnóstico precoce e a condução terapêutica da esclerose múltipla, incluindo terapias modificadoras da doença.',
    tags: ['Esclerose Múltipla', 'Neurologia'],
  },
  {
    id: '4',
    tipo: 'PCDT',
    titulo: 'PROTOCOLO CLÍNICO E DIRETRIZES TERAPÊUTICAS DA HEPATITE C',
    abrangencia: 'Nacional',
    responsavelAquisicao: 'Ministério da Saúde',
    componente: 'ESTRATÉGICO',
    status: 'REVOGADO',
    resumo:
      'Estabelece critérios de tratamento antiviral para hepatite C, incluindo esquemas terapêuticos conforme genótipo viral.',
    tags: ['Hepatite C', 'Infectologia'],
  },
  {
    id: '5',
    tipo: 'LINHA DE CUIDADO',
    titulo: 'LINHA DE CUIDADO DA DOENÇA RENAL CRÔNICA',
    abrangencia: 'Estadual - Minas Gerais',
    responsavelAquisicao: 'Secretaria de Estado de Saúde de Minas Gerais',
    componente: 'ESPECIALIZADO',
    resumo:
      'Organiza o fluxo assistencial para pacientes com doença renal crônica, desde a atenção primária até a terapia renal substitutiva.',
    tags: ['Nefrologia', 'Linha de Cuidado'],
  },
];
